module.exports = [{"header":"Scholarship inquiries","name":"Adrian Risley","photo":"/images/team/Adrian-Risley.png","title":"Community Lead","email":"adrian@playvs.com"},{"header":"Media Inquiries","name":"Lisa Santacruz","photo":"/images/team/Lisa-Santacruz.png","title":"PR Lead","email":"lisa@astrskpr.com"}]


//////////////////
// WEBPACK FOOTER
// ./src/common/ui/data/representatives.json
// module id = 219
// module chunks = 0